import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { Table, Button, Breadcrumb } from 'antd';
import AntIcon from '../shared/components/AntIcon';
import { Link } from 'react-router-dom';

import _ from 'lodash';

import { ListSneakersQuery } from './queries';

const Columns = [
  {
    title: 'Date',
    dataIndex: 'date',
    sorter: (a, b) => a.date.localeCompare(b.date),
  },
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
    render: (text, record) => <Link to={`/catalog/${record._id}/edit`}>{text}</Link>,
  },
  {
    title: 'Colorways',
    dataIndex: 'colorways',
    filters: [
      { text: "No colorways", value: 'no_colorways' },
    ],
    onFilter: (_, { colorways }) => !colorways,
    render: (colorways) => (colorways || []).length,
  },
];

class List extends Component {
  componentDidMount() {
    const { loading, fetchMore, Sneakers } = this.props.data;
    if (!loading && Sneakers) {
      const updatedSince = _(Sneakers).map('updatedAt').max();
      fetchMore({
        variables: {
          filter: {
            "updatedAt": { "$gt": updatedSince },
          },
        },
        updateQuery: (previousResult, { fetchMoreResult, _variables }) => {
          const newIds = fetchMoreResult.Sneakers.map(s => s._id);
          const Sneakers = _(previousResult.Sneakers)
            .reject(s => newIds.includes(s._id))
            .concat(fetchMoreResult.Sneakers)
            .sortBy(['_id'])
            .value();
          return { Sneakers };
        },
      })
    }
  }

  render() {
    const { loading, error, Sneakers } = this.props.data;
    if (error) return `Error: ${error}`;
    const FilteredSneakers = _.reject(Sneakers, 'isDeleted');

    return (
      <div id="catalog-list">
        <Breadcrumb>
          <Breadcrumb.Item>Catalog</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <h4>
            Manage Catalog
            <Button.Group size="small" className="is-right">
              <Button>
                <Link to="/catalog/new"><AntIcon type="plus" /> New Item</Link>
              </Button>
            </Button.Group>
          </h4>

          <Table
            scroll={{ x: 500 }}
            columns={Columns}
            loading={Sneakers ? false : loading}
            dataSource={FilteredSneakers}
            rowKey='_id'
            pagination={{
              pageSize: 30,
              showTotal: (total) => `Total ${total} items`,
            }}
          />
        </div>
      </div>
    );
  }
}

export default graphql(
  ListSneakersQuery,
)(List);
